"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESOURCE_CENTER_FILTER_UPDATED = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _axios = _interopRequireDefault(require("axios"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _wdh = require("@demant/wdh");

var _filterView = _interopRequireDefault(require("./views/filter-view"));

var _listView = _interopRequireDefault(require("./views/list-view"));

var _listItemView = _interopRequireDefault(require("./views/list-item-view"));

var _itemDetailView = _interopRequireDefault(require("./views/item-detail-view"));

var _propTypes2 = _interopRequireDefault(require("./utils/prop-types"));

var _contentType = _interopRequireDefault(require("./model/content-type"));

var _filter = _interopRequireDefault(require("./model/filter"));

var _filterManager = _interopRequireDefault(require("./utils/filter-manager"));

var _emptyResultView = _interopRequireDefault(require("./views/empty-result-view"));

var _loadingView = _interopRequireDefault(require("./views/loading-view"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RESOURCE_CENTER_FILTER_UPDATED = 'resourceCenterFilterUpdated';
exports.RESOURCE_CENTER_FILTER_UPDATED = RESOURCE_CENTER_FILTER_UPDATED;

var WDHResourceCenter = /*#__PURE__*/function (_WDHComponent) {
  _inherits(WDHResourceCenter, _WDHComponent);

  var _super = _createSuper(WDHResourceCenter);

  /**
   * Something about Resource center
   * @param {string} [selector=resource-center]
   * @constructor
   * @augments WDHComponent
   * @inheritdoc
   */
  function WDHResourceCenter() {
    var _this;

    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'resource-center';

    _classCallCheck(this, WDHResourceCenter);

    _this = _super.call(this, className);
    _this.defaultSettings = {
      errorMessage: '<p>Unfortunately we didn\'t find any items matching your query.</p>\n<p>\nPlease try to reset the filters by pressing "Clear all filters" or change your current filtering\n</p>',
      itemNotFoundErrorMessage: '<p>Document not found.</p>',
      dataEndpoint: '384340B0-02BB-43D3-B0CB-D6376EFB12C0',
      maxListCount: '2',
      baseEndpoint: '/webservices/downloads.svc/downloadslist/',
      fetchMethod: 'POST'
    };
    _this.defaultDictionary = {
      filterby: 'Filter by',
      viewall: 'Clear filters',
      closefilters: 'Close filters',
      showresults: 'Show results',
      contenttypes: 'All Content Types',
      viewallitems: 'View all {0} items',
      back: 'Back to overview',
      download: 'Download',
      file: 'file',
      pdf: 'PDF',
      img: 'image',
      video: 'video',
      embed: 'Watch embedded content',
      loadmore: 'Load more',
      freetextsearch: 'Free text search',
      clearfreetext: 'Clear'
    };
    _this.loadingViewClass = _loadingView["default"];
    _this.filterViewClass = _filterView["default"];
    _this.listViewClass = _listView["default"];
    _this.listItemViewClass = _listItemView["default"];
    _this.itemDetailViewClass = _itemDetailView["default"];
    _this.filterMode = _filterManager["default"].FILTER_MANAGER_MODE_INCLUSIVE;
    _this.reactReference = null;
    return _this;
  }

  _createClass(WDHResourceCenter, [{
    key: "init",
    value: function init(component) {
      var _this2 = this;

      var path = window.location.pathname;
      var subPathIndex = path.indexOf('/doc/');
      var basename = path.substr(0, subPathIndex > -1 ? subPathIndex : path.length);
      var LoadingViewClass = this.loadingViewClass;
      var settings = this.getSettingsFromComponent(component);

      _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(LoadingViewClass, null), component.querySelector('.component-content'));

      this.getDictionaryItems(component, function (dictionary) {
        _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, {
          basename: basename
        }, /*#__PURE__*/_react["default"].createElement(ResourceCenterWithRouter, {
          settings: settings,
          dictionary: dictionary,
          FilterViewClass: _this2.filterViewClass,
          filterMode: _this2.filterMode,
          ListViewClass: _this2.listViewClass,
          ListItemViewClass: _this2.listItemViewClass,
          GridViewClass: _this2.gridViewClass,
          GridItemViewClass: _this2.gridItemViewClass,
          ItemDetailViewClass: _this2.itemDetailViewClass,
          LoadingViewClass: _this2.loadingViewClass,
          referenceCallback: function referenceCallback(n) {
            _this2.reactReference = n;
          }
        })), component.querySelector('.component-content'));
      }, document.querySelector('html').getAttribute('lang'));
    }
  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      try {
        var settings = JSON.parse(component.querySelector('script[type="application/json"]').innerHTML);
        return _objectSpread({}, this.defaultSettings, {}, settings);
      } catch (e) {
        return this.defaultSettings;
      }
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(element) {
      if (this.reactReference) {
        this.reactReference.handleFilterElementChange(element);
      }
    }
  }, {
    key: "getDictionaryItems",
    value: function getDictionaryItems(component, callback) {
      var dictionary = _objectSpread({}, this.defaultDictionary);

      var dictionaryItems = Array.from(component.querySelectorAll('.dictionary div'));
      dictionaryItems.forEach(function (item) {
        var key = item.getAttribute('data-key');
        dictionary[key] = item.textContent;
      });
      callback(dictionary);
    }
  }]);

  return WDHResourceCenter;
}(_wdh.WDHComponent);

var ResourceCenter = /*#__PURE__*/function (_React$Component) {
  _inherits(ResourceCenter, _React$Component);

  var _super2 = _createSuper(ResourceCenter);

  _createClass(ResourceCenter, null, [{
    key: "getEmptyData",
    value: function getEmptyData() {
      return {
        contentTypes: [],
        filters: []
      };
    }
  }, {
    key: "isValidResponse",
    value: function isValidResponse(response) {
      return response.data && response.data.contentTypes && response.data.filters;
    }
  }, {
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia('(min-width: 768px)').matches;
    }
  }]);

  function ResourceCenter(props) {
    var _this3;

    _classCallCheck(this, ResourceCenter);

    _this3 = _super2.call(this, props);
    _this3.filterManager = new _filterManager["default"]();
    var _this3$props = _this3.props,
        filterMode = _this3$props.filterMode,
        referenceCallback = _this3$props.referenceCallback;
    _this3.filterManager.filterMode = filterMode;
    _this3.rawData = ResourceCenter.getEmptyData();
    _this3.dataIsLoaded = false;
    _this3.state = {
      contentTypes: _this3.rawData.contentTypes,
      filters: _this3.rawData.filters,
      isDesktop: ResourceCenter.isDesktop(),
      filtersVisible: false,
      loading: false
    };
    _this3.onShowItemDetails = _this3.onShowItemDetails.bind(_assertThisInitialized(_this3));
    _this3.onHideItemDetails = _this3.onHideItemDetails.bind(_assertThisInitialized(_this3));
    _this3.handleFilterElementChange = _this3.handleFilterElementChange.bind(_assertThisInitialized(_this3));
    _this3.handleToggleShowFilters = _this3.handleToggleShowFilters.bind(_assertThisInitialized(_this3));
    _this3.handleFilterClearAll = _this3.handleFilterClearAll.bind(_assertThisInitialized(_this3));
    _this3.parseFiltersFromQueryParams = _this3.parseFiltersFromQueryParams.bind(_assertThisInitialized(_this3));
    _this3.handleFreeTextSearch = _this3.handleFreeTextSearch.bind(_assertThisInitialized(_this3));
    referenceCallback(_assertThisInitialized(_this3));
    return _this3;
  }

  _createClass(ResourceCenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      this.getItemsFromEndpoint().then(function () {
        _this4.dataIsLoaded = true;
        _this4.filterManager.categoryMappings = _this4.rawData.filters;

        _this4.parseFiltersFromQueryParams();

        _this4.updateStateWithItems();
      });
      (0, _wdh.onResize)(function () {
        _this4.setState({
          isDesktop: ResourceCenter.isDesktop()
        });
      });
    }
    /**
     * Sets the passed Item as the selected item.
     * @param {Event} event
     * @param {Item} selectedItem
     */

  }, {
    key: "onShowItemDetails",
    value: function onShowItemDetails(event, selectedItem) {
      event.preventDefault();

      if (selectedItem.shouldDownload()) {
        window.open(selectedItem.url, '_blank');
      } else {
        var _this$props = this.props,
            history = _this$props.history,
            location = _this$props.location;
        history.push({
          pathname: "/doc/".concat(selectedItem.id),
          search: location.search
        });
      }
    }
  }, {
    key: "onHideItemDetails",
    value: function onHideItemDetails() {
      var _this$props2 = this.props,
          history = _this$props2.history,
          location = _this$props2.location;
      history.push({
        pathname: '/',
        search: location.search
      });
    }
  }, {
    key: "getItemsFromEndpoint",
    value: function getItemsFromEndpoint() {
      var _this5 = this;

      var settings = this.props.settings;
      this.setState({
        loading: true
      });
      var language = window.document.documentElement.lang;
      var endPoint = "".concat(settings.baseEndpoint, "/").concat(settings.dataEndpoint).concat(!language ? '' : "/".concat(language));
      return (0, _axios["default"])({
        method: settings.fetchMethod,
        url: endPoint,
        data: {}
      }).then(function (response) {
        _this5.rawData = ResourceCenter.isValidResponse(response) ? {
          contentTypes: _contentType["default"].fromEndpoint(response.data.contentTypes),
          filters: _filter["default"].fromEndpoint(response.data.filters)
        } : ResourceCenter.getEmptyData();
      })["finally"](function () {
        return _this5.setState({
          loading: false
        });
      });
    }
    /**
     * Parses and validates filters set in query params
     */

  }, {
    key: "parseFiltersFromQueryParams",
    value: function parseFiltersFromQueryParams() {
      var _this$props3 = this.props,
          location = _this$props3.location,
          settings = _this$props3.settings; // Gets everything from 'filters=foo,bar&otherparam=xxx' up until '&' excluding 'filters='
      // result: 'foo,bar'

      var queryValue = location.search.match(/(?:\?filters=)([^&]+)/); // convert it to an array

      var filtersFromQueryParams = queryValue && queryValue[1] && queryValue[1].split(',');
      var filters = [];

      if (filtersFromQueryParams) {
        filters = filtersFromQueryParams;
      } else if (settings.filtersPredefined) {
        filters = JSON.parse(settings.filtersPredefined);
      } // Flatten all filter ids from rawData.filters[].elements[].id into one single array


      var allFilters = this.rawData.filters.map(function (filter) {
        return filter.elements.map(function (element) {
          return element.id;
        });
      }).flat(); // Exclude non-valid filter ids.

      var validFilterIds = filters.reduce(function (acc, key) {
        return allFilters.indexOf(key) > -1 ? _objectSpread({}, acc, _defineProperty({}, key, true)) : acc;
      }, {}); // Apply the filters in filterManager

      this.filterManager.filterIds = validFilterIds;
    }
  }, {
    key: "handleFilterClearAll",
    value: function handleFilterClearAll() {
      this.filterManager.clearFilters();
      this.updateStateWithItems();
    }
  }, {
    key: "handleFilterElementChange",
    value: function handleFilterElementChange(element) {
      // element.selected = !element.selected;
      this.filterManager.updateFilter(element);
      this.updateStateWithItems();
    }
  }, {
    key: "handleFreeTextSearch",
    value: function handleFreeTextSearch(textSearch) {
      this.filterManager.updateFreeTextSearch(textSearch);
      this.updateStateWithItems();
    }
  }, {
    key: "handleToggleShowFilters",
    value: function handleToggleShowFilters() {
      var filtersVisible = this.state.filtersVisible;
      this.setState({
        filtersVisible: !filtersVisible
      });
    }
  }, {
    key: "updateStateWithItems",
    value: function updateStateWithItems() {
      if (!this.dataIsLoaded) return;
      var _this$props4 = this.props,
          history = _this$props4.history,
          location = _this$props4.location;
      var filters = this.state.filters;
      var filterIds = Object.keys(this.filterManager.filterIds);
      history.push({
        pathname: location.pathname,
        search: filterIds.length ? "?filters=".concat(filterIds) : ''
      });
      this.setState({
        contentTypes: this.filterManager.parseContentTypes(this.rawData.contentTypes),
        filters: this.filterManager.parseFilters(this.rawData.filters)
      }, function () {
        (0, _wdh.triggerEvent)(RESOURCE_CENTER_FILTER_UPDATED, filters);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props5 = this.props,
          FilterViewClass = _this$props5.FilterViewClass,
          ListViewClass = _this$props5.ListViewClass,
          ItemDetailViewClass = _this$props5.ItemDetailViewClass,
          ListItemViewClass = _this$props5.ListItemViewClass,
          LoadingViewClass = _this$props5.LoadingViewClass,
          settings = _this$props5.settings,
          dictionary = _this$props5.dictionary;
      var _this$state = this.state,
          isDesktop = _this$state.isDesktop,
          filters = _this$state.filters,
          contentTypes = _this$state.contentTypes,
          filtersVisible = _this$state.filtersVisible,
          loading = _this$state.loading;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "outer-container ".concat(isDesktop ? 'desktop-section' : 'mobile-section')
      }, !loading && /*#__PURE__*/_react["default"].createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/_react["default"].createElement(FilterViewClass, {
        settings: settings,
        dictionary: dictionary,
        isDesktop: isDesktop,
        filters: filters,
        filtersVisible: filtersVisible,
        onChange: this.handleFilterElementChange,
        onClearAll: this.handleFilterClearAll,
        onToggleShowFilters: this.handleToggleShowFilters,
        filterButtonLabel: dictionary.filterby,
        clearAllButtonLabel: dictionary.viewall,
        closeFiltersButtonLabel: dictionary.closefilters,
        onFreeTextSearchChange: this.handleFreeTextSearch
      }), !!contentTypes.length && /*#__PURE__*/_react["default"].createElement(ListViewClass, {
        settings: settings,
        dictionary: dictionary,
        isDesktop: isDesktop,
        contentTypes: contentTypes,
        ListItemViewClass: ListItemViewClass,
        onItemClick: this.onShowItemDetails
      }), !contentTypes.length && /*#__PURE__*/_react["default"].createElement(_emptyResultView["default"], {
        errorMessage: settings.errorMessage
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: "/doc/:id",
        render: function render(props) {
          var allItems = _this6.rawData.contentTypes.map(function (type) {
            return type.items;
          }).flat();

          var selectedItem = allItems.find(function (item) {
            return item.id === props.match.params.id;
          });

          if (selectedItem) {
            return /*#__PURE__*/_react["default"].createElement(ItemDetailViewClass // eslint-disable-next-line react/jsx-props-no-spreading
            , _extends({}, props, {
              settings: settings,
              dictionary: dictionary,
              isDesktop: isDesktop,
              item: selectedItem,
              onClose: _this6.onHideItemDetails
            }));
          }

          return /*#__PURE__*/_react["default"].createElement(_emptyResultView["default"], {
            errorMessage: settings.itemNotFoundErrorMessage
          });
        }
      })), loading && /*#__PURE__*/_react["default"].createElement(LoadingViewClass, null));
    }
  }]);

  return ResourceCenter;
}(_react["default"].Component);

ResourceCenter.propTypes = {
  settings: _propTypes2["default"].settings.isRequired,
  dictionary: _propTypes2["default"].dictionary.isRequired,
  FilterViewClass: _propTypes["default"].func.isRequired,
  ListViewClass: _propTypes["default"].func.isRequired,
  ListItemViewClass: _propTypes["default"].func.isRequired,
  ItemDetailViewClass: _propTypes["default"].func.isRequired,
  LoadingViewClass: _propTypes["default"].func.isRequired,
  history: _propTypes["default"].shape({
    push: _propTypes["default"].func.isRequired
  }).isRequired,
  location: _propTypes["default"].shape({
    pathname: _propTypes["default"].string.isRequired,
    search: _propTypes["default"].string.isRequired
  }).isRequired,
  filterMode: _propTypes["default"].string.isRequired,
  referenceCallback: _propTypes["default"].func.isRequired
};
ResourceCenter.defaultProps = {};
var ResourceCenterWithRouter = (0, _reactRouterDom.withRouter)(ResourceCenter);
var _default = WDHResourceCenter;
exports["default"] = _default;